import { DATE_FORMAT } from '@app/configs/dateTime';
import { getLocalDateTime } from '@app/utils/time';
import formatAmount from '@modules/calculator/utils/formatAmount';
import { getFundingProgress } from './getFundingProgress';
export const mapOpportunitiesToColumns = (opportunities, t) => opportunities.map((opportunity) => ({
    id: opportunity.id,
    investmentDeadline: getLocalDateTime(opportunity.investmentDeadline, DATE_FORMAT.dateTime),
    loanPurpose: opportunity.loanPurpose,
    loanAmount: formatAmount(+opportunity.loanAmount),
    loanPeriod: `${opportunity.loanPeriod} ${t('financing.investing_page_table.months')}`,
    roi: `${opportunity.roi}%`,
    riskScore: opportunity.riskScore,
    fundingProgress: getFundingProgress(opportunity),
}));
